import { FormNames } from '@youscience/commonapp-service-common';

import FormActionButtons from '@pages/StudentDetailsPage/components/FormActionButtons';

import { StyledFormFooter } from './FormFooter.styles';

export interface FormFooterProps {
  onPreviewClick: () => void;
  onSaveForLaterClick: () => void;
  onSubmitClick: () => void;
  onUnsubmitClick: () => void;
  areAllActionsDisabled?: boolean;
  isSubmitDisabled?: boolean;
  isFormSumbitted: boolean;
  formName: FormNames;
}

export const FormFooter = ({
  onPreviewClick,
  onSaveForLaterClick,
  onSubmitClick,
  onUnsubmitClick,
  areAllActionsDisabled,
  isSubmitDisabled,
  isFormSumbitted,
  formName,
}: FormFooterProps) => {
  return (
    <StyledFormFooter>
      {isFormSumbitted ? null : (
        <FormActionButtons
          onPreviewClick={onPreviewClick}
          onSaveForLaterClick={onSaveForLaterClick}
          onSubmitClick={onSubmitClick}
          onUnsubmitClick={onUnsubmitClick}
          areAllActionsDisabled={areAllActionsDisabled}
          isSubmitDisabled={isSubmitDisabled}
          isFormSumbitted={isFormSumbitted}
          formName={formName}
        />
      )}
    </StyledFormFooter>
  );
};
